import { cookieStore } from '../../utils/polyfills/cookie-store';

const trackingIds = [
  "AW-10900283657",
  "G-Q11NVWDXX2",
  // "UA-83910929-4"
];

export const initGoogleAnalytics = async () => {
  if (typeof window === 'undefined') return;

  const wp21marketing = await cookieStore.get('wp21marketing');

  if (wp21marketing && wp21marketing.value === 'true') {
    addGoogleAnalytics().then(() => {
      configureGoogleAnalytics()
    })
  }
};

export const addGoogleAnalytics = () => {
  return Promise.all(trackingIds.map((trackingId) =>
    new Promise((resolve) => {
      if (window[`googleAnalyticsAdded_${trackingId}`]) {
        return resolve(true)
      }

      const head = document.getElementsByTagName('head')[0]
      const script = document.createElement(`script`)
      script.type = `text/javascript`
      script.onload = (e) => {
        window[`googleAnalyticsAdded_${trackingId}`] = true
        resolve(true)
      }
      script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`

      head.appendChild(script);
    })
  ))
}

export const configureGoogleAnalytics = () => {
  const pagePath = window.location.pathname + window.location.search + window.location.hash

  if (document.getElementById('google-analytics-config')) {
    gtag('event', 'page_view', { page_path: pagePath })
    return;
  }

  const head = document.getElementsByTagName('head')[0]
  const script = document.createElement(`script`)
  script.type = `text/javascript`
  script.id = 'google-analytics-config'
  script.innerHTML = `
  window.dataLayer = window.dataLayer || [];
  function gtag() { dataLayer.push(arguments); }
  gtag('js', new Date());

  setTimeout(() => {
    gtag('consent', 'default', {
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      ad_storage: 'denied',
      analytics_storage: 'denied',
    });

    setTimeout(() => {
      gtag('consent', 'update', {
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        ad_storage: 'granted',
        analytics_storage: 'granted',
      });

      gtag('event', 'page_view', {page_path: '${pagePath}'});

      ${trackingIds.map((trackingId) => {
    return (`
              gtag('config', '${trackingId}', {
                anonymize_ip: true,
                cookie_expires: 0,
                custom_map: {
                  dimension1: "inquiry_id",
                },
              });
              `
    )
  }).join('\n')}

      }, Math.floor(Math.random() * (800 - 200 + 1)) + 200);
  }, 1)
    `;

  head.appendChild(script);
}
